<span class="version-info">
  <p>version: {{ version }}</p>
</span>
